import styled from "styled-components";

export const SpanDiscount = styled.span`
  & {
    display: flex;
    color: white;
    width: max-content;
    margin: 10px 0;
    text-align: center;
    background-color: var(--live-button-color);
    padding: 2px 8px;
    line-height: 1;

    @media (max-width: 1225px) {
      margin: 0;
    }
  }
`;
